'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var icons = require('@tempi/icons');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Store = ({ store, mainColor }) => {
  const { name, address, phone, workHours, map } = store;
  const [showMap, setShowMap] = React.useState(false);
  return /* @__PURE__ */ jsxRuntime.jsxs(StoreWrapper, {
    mainColor,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx("div", {
        className: "store-name",
        children: /* @__PURE__ */ jsxRuntime.jsx("b", {
          children: name
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs("div", {
        className: "store-details",
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs("div", {
            className: "store-address",
            children: [
              /* @__PURE__ */ jsxRuntime.jsx("b", {
                children: "\u0110\u1ECBa ch\u1EC9: "
              }),
              address
            ]
          }),
          /* @__PURE__ */ jsxRuntime.jsxs("div", {
            className: "bottom-elements",
            children: [
              /* @__PURE__ */ jsxRuntime.jsxs("div", {
                className: "store-info",
                children: [
                  /* @__PURE__ */ jsxRuntime.jsxs("div", {
                    className: "store-phone",
                    children: [
                      /* @__PURE__ */ jsxRuntime.jsx("b", {
                        children: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i: "
                      }),
                      /* @__PURE__ */ jsxRuntime.jsx("span", {
                        children: phone
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsxRuntime.jsxs("div", {
                    className: "store-working-hours",
                    children: [
                      /* @__PURE__ */ jsxRuntime.jsx("b", {
                        children: "Gi\u1EDD m\u1EDF c\u1EEDa: "
                      }),
                      /* @__PURE__ */ jsxRuntime.jsx("span", {
                        children: workHours
                      })
                    ]
                  })
                ]
              }),
              map && /* @__PURE__ */ jsxRuntime.jsxs("button", {
                onClick: () => setShowMap(!showMap),
                className: "map-toggle",
                children: [
                  "T\xECm \u0111\u01B0\u1EDDng",
                  " ",
                  showMap ? /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    name: "ArrowDownTinyFilled"
                  }) : /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    name: "ArrowUpTinyFilled"
                  })
                ]
              })
            ]
          })
        ]
      }),
      showMap && map && /* @__PURE__ */ jsxRuntime.jsx("div", {
        className: "store-map",
        children: map.startsWith("<iframe") ? /* @__PURE__ */ jsxRuntime.jsx("div", {
          dangerouslySetInnerHTML: {
            __html: map
          }
        }) : /* @__PURE__ */ jsxRuntime.jsx("iframe", {
          src: map,
          title: "map",
          allowFullScreen: true
        })
      })
    ]
  });
};
const StoreWrapper = styled__default["default"].div(
  ({ mainColor }) => `
  line-height: 2;
  padding: 0.8em 1.5em;
  background-color: white;
  border-bottom: 1px solid #eaeaea;

  &:hover{
    background: ${mainColor.slice(0, 7) + "10"};
  }


  .store-name{
    font-size: 1.4em;
    color: ${mainColor};
  }

  .store-details{
    position: relative;

    .bottom-elements{
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .store-info{
        display: inline-block;
        margin-right: auto;
        padding-bottom: 0.5em;
      }   

      .map-toggle{
        border: 1px solid ${mainColor};
        background-color: white;
      
        height: 40px;
        color: ${mainColor};
        line-height: 40px;
        display: block;
        padding: 0 15px;
        border-radius: 4px;
        outline-color: ${mainColor};

        svg{
          vertical-align: baseline;
        }
      }
    }
  }
  
  .store-map{
    margin-top: 1em;

    iframe{
      width: 100%;
      border: none;
      border-radius: 1em;
    }
  }
`
);

exports.Store = Store;
